<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>   
    <template v-slot:right_view>
      <NSSIList></NSSIList>
    </template>
  </BasicLayout>
</template>
<script>
import BasicLayout from '../../layouts/BasicLayout';
import NSSIList from '../../components/nsmfconfig/nssi/NSSIList';

export default {
  name: 'nssiPage',
  components: {
    BasicLayout,
    NSSIList
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('NSMF.nsmfManage')}/${this.$t('NSMF.nssi')}`
      }
    };
  }
};
</script>